import React from "react";
import PropTypes from "prop-types";

class ReactTableYesNoFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: ""
        };
    }

    componentDidMount() {
        // Initialize with current filter value if it exists
        const { filter } = this.props;
        if (filter && filter.value !== undefined) {
            this.setState({ value: filter.value });
        }
    }

    handleChange = (event) => {
        const value = event.target.value;
        this.setState({ value });
        this.props.onChange(value === "" ? undefined : value);
    };

    render() {
        const { value } = this.state;
        const { style } = this.props;

        return (
            <select
                onChange={this.handleChange}
                value={value}
                style={{ 
                    width: "100%", 
                    height: "100%", 
                    padding: "4px",
                    border: "1px solid #ccc",
                    borderRadius: "3px",
                    ...style 
                }}
            >
                <option value="">All</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
            </select>
        );
    }
}

ReactTableYesNoFilter.propTypes = {
    onChange: PropTypes.func.isRequired,
    filter: PropTypes.object,
    style: PropTypes.object
};

export default ReactTableYesNoFilter;
